import { IDatePickerStrings ,DayOfWeek } from 'office-ui-fabric-react/lib/DatePicker';

export class Config {
    constructor() {

        this.version = '2.0.260112.1';
        
        var location = window.location;
        this.ENV = process.env.NODE_ENV;
        
        if( this.ENV === 'development'){ this._baseUrl = "http://localhost:80/src/test"; }
        else { this._baseUrl = location.origin+'/AC2/'; } // questo sarà il definitivo di produzione, da modificare
        
        this.tentativiAutologin = 80; // X per 50 mllisecondi
        
        this.internalConfig = {
            "customers_configurazioni" : this._baseUrl + "api/customers/configurazioni",
            
            "customers_login" : this._baseUrl + "api/customers/login",
            "customers_autologin" : this._baseUrl + "api/customers/autologin",
            "customers_firstlogin" : this._baseUrl + "api/customers/firstlogin",
            "customers_logout": this._baseUrl + "api/customers/logout",
            
            // 2019-10-08
            "customers_firstloginmail" : this._baseUrl + "api/customers/firstloginmail",
            "customers_completaregister" : this._baseUrl + "api/customers/completaregister",
            "customers_eliminaaccount" : this._baseUrl + "api/customers/eliminaaccount",
            "customers_cancellapassword" : this._baseUrl + "api/customers/cancellapassword",
            
            // 2019-10-23
            "anagrafica_elencoutenti": this._baseUrl + "api/anagrafica/elencoutenti",
            
            "anagrafica_cliente": this._baseUrl + "api/anagrafica/cliente",
            "anagrafica_fatture": this._baseUrl + "api/anagrafica/fatture",
            "anagrafica_richieste": this._baseUrl + "api/anagrafica/richieste",
            "anagrafica_contratti": this._baseUrl + "api/anagrafica/contratti", 
            
            "anagrafica_moduli": this._baseUrl + "api/anagrafica/moduli",  // DOCUMENTI GENERALI
            "anagrafica_curve": this._baseUrl + "api/anagrafica/curve",
            "anagrafica_registri": this._baseUrl + "api/anagrafica/registri",
            
            "anagrafica_registriall": this._baseUrl + "api/anagrafica/registriall",
            
            "anagrafica_datiCatastali": this._baseUrl + "api/anagrafica/datiCatastali",
            "anagrafica_documenti": this._baseUrl + "api/anagrafica/documenti",
            
            "utility_salvaDatiCatastali": this._baseUrl + "api/utility/salvaDatiCatastali",
            "utility_caricaComuni": this._baseUrl + "api/utility/caricaComuni",
            "utility_inviamailHome": this._baseUrl + "api/utility/inviamailHome",
            "utility_scaricafile": this._baseUrl + "api/utility/scaricafile",
            "utility_inviaAutoletture": this._baseUrl + "api/utility/inviaAutoletture",
            "utility_inviaPrivacy": this._baseUrl + "api/utility/inviaPrivacy",
            
            // vecchia AC - serve per redirigere Accesso Amm. Condominio e Aggregati
            "old_ac_url" : location.origin.replace('/AC2/build' , ''),
            "pathAC2" : location.origin + location.pathname,  // path nuova Area CLIENTI 2
            
            "scaricapdfapi": this._baseUrl + "api/scaricaPdfFattura.php",
        };
        
        this.getCustomersLogin = this.getCustomersLogin.bind(this);
        this.getLogout = this.getLogout.bind(this);
        this.get = this.get.bind(this);
        this.getVersion = this.getVersion.bind(this);
        this.getEnv = this.getEnv.bind(this);
        this.getLocation = this.getLocation.bind(this);
        this.getDayPickerStrings = this.getDayPickerStrings.bind(this);
        this.getPrimoGiornoSettimana = this.getPrimoGiornoSettimana.bind(this);
        this.getPaletteBase = this.getPaletteBase.bind(this);
        this.getMaskAutolettura = this.getMaskAutolettura.bind(this);
        this.getMaskAutoletturaDecimalPotenza = this.getMaskAutoletturaDecimalPotenza.bind(this);
        this.getTentativiAutologin = this.getTentativiAutologin.bind(this);
        this.isAuthLink = this.isAuthLink.bind(this);
        this.getReCaptchaClient = this.getReCaptchaClient.bind(this);
        this.getReCaptchaServer = this.getReCaptchaServer.bind(this);
        this.getReCaptchaClientV3 = this.getReCaptchaClientV3.bind(this);
        this.getReCaptchaServerV3 = this.getReCaptchaServerV3.bind(this);
        
        // console.log(  "WINDOW.LOCATION" , window.location );
    }
    
    getVersion(){ return this.version; }
    getEnv(){ return this.ENV; }
    getLocation(){ return window.location.origin; }
    
    getCustomersLogin() { return this.internalConfig.customers_login; }
    getLogout() { return this.internalConfig.customers_logout; }
    get(index) { return this.internalConfig[index]; }

    getDayPickerStrings()
    {
        const DayPickerStrings: IDatePickerStrings = {
            months: [ 'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre' ],
            shortMonths: ['Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu', 'Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic'],
            days: ['Domenica', 'Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato'],
            shortDays: ['D', 'L', 'M', 'M', 'G', 'V', 'S'],
            goToToday: 'Vai a Oggi',
            prevMonthAriaLabel: 'Vai al mese precedente',
            nextMonthAriaLabel: 'Vai al prossimo mese',
            prevYearAriaLabel: 'Vai all\'anno precedente',
            nextYearAriaLabel: 'Vai al prossimo Anno'
          };
        
        return DayPickerStrings;
    }
    
    getPrimoGiornoSettimana(){ return DayOfWeek.Monday; }
    
    getToday(){
        return new Date();
    }
    
    getLastDayMonth(){
        let today = this.getToday();
        let year = today.getFullYear();
        let month = today.getMonth();
        
        let lastday = new Date(year, month + 1, 0);
        return lastday;
    }
    
    controllaErroriImpostazioniDate(dadataadata){
        
        // mi aspetto qualcosa del tipo 27-01 , o 02-05
        dadataadata = dadataadata.replace(/[0-9]+/g, ''); 

        // tolti i numeri deve rimanere solo il -

        if( dadataadata === '' || dadataadata === '-' ) return false; // il formato è corretto
        else return true; // qui il formato è sbagliato

    }
    
    getFirstDayByCode(dadataadata){
        let pz = dadataadata.split('-');
        
        let dayA = parseInt(pz[0] , 10);
        let dayB = parseInt(pz[1] , 10);
        
        let day=0;
        if(dayA > dayB){
            // es: formato 29-05
            day = dayA
        }
        else
        {
            // esempio 07-10
            day = dayA; // pesco però tutto nello stesso mese
        }
        
        let today = this.getToday();
        let year = today.getFullYear();
        let month = today.getMonth();
        
        let firstday = new Date(year, month, day);
        return firstday;
    }
    
    getLastDayByCode(dadataadata){
        let pz = dadataadata.split('-');
        
        let dayA = parseInt(pz[0] , 10);
        let dayB = parseInt(pz[1] , 10);
        
        let day=0;
        let addMonth=0;
        if(dayA > dayB){
            // es: formato 29-05
            day = dayB
            addMonth=1;
        }
        else
        {
            // esempio 07-10
            day = dayB;
            addMonth=0;
        }
        
        let today = this.getToday();
        let year = today.getFullYear();
        let month = today.getMonth();
        
        let lastday = new Date(year, month+addMonth, day);
        return lastday;
    }
    
    getLastYear(){
        let today = this.getToday();
        let year = today.getFullYear();
        let month = today.getMonth();
        
        let lastyear = new Date(year-1, month, 0);
        return lastyear;
    }
    
    getNextYear(){
        let today = this.getToday();
        let year = today.getFullYear();
        let month = today.getMonth();
        
        let nextyear = new Date(year+1, month, 0);
        return nextyear;
    }
    
    getPaletteBase()
    {
        return {
            // configurazione THEME FABRIC WINDOWS Default
            "themePrimary": "#0078d4",
            "themeLighterAlt": "#eff6fc",
            "themeLighter": "#deecf9",
            "themeLight": "#c7e0f4",
            "themeTertiary": "#71afe5",
            "themeSecondary": "#2b88d8",
            "themeDarkAlt": "#106ebe",
            "themeDark": "#005a9e",
            "themeDarker": "#004578",
            "neutralLighterAlt": "#f8f8f8",
            "neutralLighter": "#f4f4f4",
            "neutralLight": "#eaeaea",
            "neutralQuaternaryAlt": "#dadada",
            "neutralQuaternary": "#d0d0d0",
            "neutralTertiaryAlt": "#c8c8c8",
            "neutralTertiary": "#c2c2c2",
            "neutralSecondary": "#858585",
            "neutralPrimaryAlt": "#4b4b4b",
            "neutralPrimary": "#333",
            "neutralDark": "#272727",
            "black": "#1d1d1d",
            "white": "#fff",
            "bodyBackground": "#fff",
            "bodyText": "#333",
    
            "yellow": "#ffb900",
            "yellowLight": "#fff100",
            
            "orange": "#d83b01",
            "orangeLight": "#ea4300",
            "orangeLighter": "#ff8c00",
            
            "redDark": "#a80000",
            "red": "#e81123",

            'headerLogin' : '0px',
            'footerLogin' : '0px',
            'backgroundHeightLogin' : '100%'
          };
    }

    getMaskAutolettura()
    {
        // 9: 0-9
        // a: A-Z, a-z
        // *: A-Z, a-z, 0-9
        
        return '999999999';
    }

    getMaskAutoletturaDecimalPotenza()
    {
        // 9: 0-9
        // a: A-Z, a-z
        // *: A-Z, a-z, 0-9
        
        return '99.99';
    }
    
    getTentativiAutologin(){ return this.tentativiAutologin; }
    
    isAuthLink(){
        // console.log(window.location);
        //  http://localhost:3000/?auth=jhdksgsdfhjsdfkljhsdfjkhlgh
        if( window.location.search.indexOf("?auth=") > -1 ) return true;
        return false;
    }
    
    isRegistraLink(){
        // console.log(window.location);
        //  http://localhost:3000/?registra=true&CC=123445&PIVA=0012564%MAIL=
        if( window.location.search.indexOf("?registra=true") > -1 ) return true;
        return false;
    }
    
    leggiParametri(){
        // https://davidwalsh.name/query-string-javascript
        var urlParams = new URLSearchParams(window.location.search);
        
        return urlParams;
    }
    
    // reCaptcha V2 - account Flossi
    getReCaptchaClient(){ return "6LfqgL0UAAAAACXM9JlaXM3lSaq6CsoU32w3aceS"; }
    getReCaptchaServer(){ return "6LfqgL0UAAAAAJes-mDJn0KbNGdNRdEdVKGXjja6"; }
    
    // reCaptcha V3 - account Flossi
    getReCaptchaClientV3(){ return "6Ldefr0UAAAAAOFShAfOnZaNAc--bZCrhdCTp1DJ"; }
    getReCaptchaServerV3(){ return "6Ldefr0UAAAAAItkAR9bXaR87Jb4Fu9tMwPYssJM"; }
}

export default Config;


// WEBPACK FOOTER //
// ./src/AcComponents/Config.js